import React, { useEffect, useState } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { addCustomPlan, updateCustomPlanData } from '../../actions/userActions';
import { toast } from 'react-toastify';

const EditPlan = ({ openNew, setOpenNew, selectedData }) =>
{
	const [ plans, setPlans ] = useState([
		{ id: 1, planName: '', months: 0, type: 'planD' }
	]);

	const [ title, setTitle ] = useState('');
	const [ code, setCode ] = useState('');

	const handlePlanChange = (id, field, value) =>
	{
		const updatedPlans = [ ...plans ];
		const planIndex = updatedPlans.findIndex((plan) => plan.id === id);

		if (planIndex !== -1)
		{
			updatedPlans[planIndex][field] = value;
			setPlans(updatedPlans);
		}
	};

	const handleSubmit = () =>
	{
		if (!title)
		{
			toast.error('Title is required');

			return;
		}
		if (!code)
		{
			toast.error('Code is required');

			return;
		}
		if (/\s/.test(code))
		{
			toast.error('Code should not contain spaces');

			return;
		}

		let hasError = false;

		plans.forEach((plan) =>
		{
			if (!plan.planName)
			{
				toast.error('Plan Choose the License');
				hasError=true;

				return;
			}

			if (!plan.months)
			{
				toast.error('Months must be greater than 0.');
				hasError=true;

				return;
			}
		});

		if (hasError)
		{
			return;
		}

		updateCustomPlanData({ id: selectedData?._id, title: title, license: plans, code: code }).then((res) =>
		{

			if (res?.data?.status)
			{
				toast.success('Plan added successfully');
				setPlans([ { id: 1, planName: '', months: 0, type: 'planD' } ]);
				setTitle('');
				setOpenNew(false);
				setCode('');
			}
			else
			{
				toast.error(res.data.message);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log('err === ', err);
				toast.error('Internal server error, Please try again');
			});
	};

	const deleteRow = (id) =>
	{
		if (plans.length>1)
		{
			const updatedPlans = plans.filter((plan) => plan.id !== id);

			const reindexedPlans = updatedPlans.map((plan, index) => ({
				...plan,
				id : index + 1
			}));

			setPlans(reindexedPlans);
		}
	};

	const addRow = () =>
	{
		const newId = plans.length ? plans[plans.length - 1].id + 1 : 1;

		setPlans([ ...plans, { id: newId, planName: '', months: 0, type: 'planD' } ]);
	};

	useEffect(() =>
	{
		setTitle(selectedData?.title);
		setPlans(selectedData?.license);
		setCode(selectedData?.code);
	}, [ selectedData ]);

	return (
		<div className='addPlanWrapper'>
			{ openNew ?
				<Dialog open={openNew}>
					<DialogTitle>Edit Package</DialogTitle>
					<DialogContent>
						<div className='p-4'>
							<TextField
								margin='dense'
								variant='standard'
								id='title'
								label='Plan Title'
								type='text'
								fullWidth
								value={title}
								onChange={(e) => setTitle(e.target.value)}
							/>
							<TextField
								margin='dense'
								variant='standard'
								id='code'
								label='Code'
								type='text'
								fullWidth
								value={code}
								onChange={(e) => setCode(e.target.value)}
							/>
							<table className='table table-bordered'>
								<thead>
									<tr>
										<th>#</th>
										<th>Plan License</th>
										<th>No. of Months</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
									{plans.map((plan, index) => (
										<tr key={plan.id}>
											<td>{plan.id}</td>
											<td>
												<select
													className='form-select'
													value={plan.planName}
													onChange={(e) =>
														handlePlanChange(plan.id, 'planName', e.target.value)
													}
												>
													<option value=''>Select License</option>
													<option value='customerPlanA'>Personal Conference Room for $6/month</option>
													<option value='customerPlanB'>Basic Conference Room for $11/month</option>
													<option value='customerPlanC'>Basic Pro Conference Room for $21/month</option>
													<option value='customerPlanD'>KonX eCard for $41</option>
													<option value='EnterpriseRoom'>Enterprise Conference Room for $81/month</option>
													<option value='BusinessRoom'>Business Conference Room for $26/month</option>
													<option value='CorporateRoom'>Corporate Conference Room for $51/month</option>
												</select>
											</td>
											<td>
												<input
													type='number'
													className='form-control'
													min='1'
													max='12'
													value={plan.months}
													onChange={(e) =>
														handlePlanChange(plan.id, 'months', e.target.value)
													}
												/>
											</td>
											<td>
												<span className='cursor-pointer' onClick={() => deleteRow(plan.id)}><DeleteIcon/></span>
												{plans.length-1===index?
													<span className='cursor-pointer ms-2' onClick={addRow}><AddIcon/></span>
													:null}
											</td>
										</tr>
									))}
								</tbody>
							</table>
							<div className='text-end mt-2'>
								<Button onClick={() => setOpenNew(false)}>Cancel</Button>
								<Button onClick={handleSubmit}>Save</Button>
							</div>
						</div>
					</DialogContent>
				</Dialog>
				:
				null
			}
		</div>
	);
};

export default EditPlan;